import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const GPU_EXPORTER_SCRIPT_QUERY_KEY = 'gpu-exporter-script';

type UseGpuExporterScriptQueryProps = { clusterId: string };

const getGpuExporterScriptQueryKey = (clusterId: string) =>
  [GPU_EXPORTER_SCRIPT_QUERY_KEY, clusterId] as const;

const getGpuExporterScriptQueryOptions = ({
  clusterId,
}: UseGpuExporterScriptQueryProps) =>
  queryOptions({
    queryKey: getGpuExporterScriptQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getGpuExporterScript({
        clusterId,
      });
      return data.script;
    },
    enabled: !!clusterId,
  });

export const useGpuExporterScriptQuery = (
  props: UseGpuExporterScriptQueryProps
) => {
  return useQuery(getGpuExporterScriptQueryOptions(props));
};
